'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('planstatus', {
        url: '/planstatus',
        template: '<planstatus></planstatus>'
    });
}



// WEBPACK FOOTER //
// ./client/app/planstatus/planstatus.routes.js